export const RETRIEVE_ADDITIONAL_ITEMS = 'commercial/additionalItems/retrieve';
export const RETRIEVE_ADDITIONAL_ITEM = 'commercial/additionalItems/getById';
